// ** React Imports
import { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";

// ** Icons Imports
import { Disc, X, Circle, Minimize, Maximize, ArrowLeft, ArrowDown } from "react-feather";

// ** Config
import themeConfig from "@configs/themeConfig";
import { getHomeRouteForLoggedInUser, getUserData } from "@src/utility/Utils";
import { useTranslation } from "react-i18next";
import { notNullString } from "@src/utility/StringUtil";

// Importando a mini logo no caminho que você forneceu
import miniLogo from "@src/assets/images/logo/new-mini-logo.svg";

// ** Utils
interface VerticalMenuHeaderProps {
  menuCollapsed: any
  setMenuCollapsed:any
  setMenuVisibility:any
  setGroupOpen:any
  menuHover:any
}

const VerticalMenuHeader = (
  {menuCollapsed,
  setMenuCollapsed,
  setMenuVisibility,
  setGroupOpen,
  menuHover}:VerticalMenuHeaderProps) => {
  // ** Props


  // ** Vars
  const { t } = useTranslation();
  const user = getUserData();
  const aRef = useRef<HTMLAnchorElement>(null);
  
  // LOGICA ADICIONADA IGUAL AO USER DROPDOWN: 
  // Verifica se o menu está expandido (mouse em cima ou não colapsado)
  const isExpanded = menuHover || !menuCollapsed;

useEffect(() => {
  if (aRef.current) {
    aRef.current.focus();
  }
}, []);

  // ** Reset open group
  useEffect(() => {
    if (!menuHover && menuCollapsed) setGroupOpen([]);
  }, [menuHover, menuCollapsed, setGroupOpen]);

  // ** Menu toggler component
  interface TogglerProps {
    hidden?: boolean
  }
  const Toggler = ({ hidden }: TogglerProps) => {
  if (hidden) return null;

  const handleToggle = () => setMenuCollapsed(!menuCollapsed);

  return (
    <button
      type="button"
      onClick={handleToggle}
      /* Sugestão: troque d-xl-block por d-xl-inline-flex para alinhar o ícone perfeitamente ao centro */
      className="text-primary toggle-icon d-none d-xl-inline-flex align-items-center justify-content-center button-toggle-menu"
      aria-label={menuCollapsed ? "Expandir menu" : "Recolher menu"}
      aria-expanded={!menuCollapsed}
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: 0 // Mantém a caixa original pequena para não quebrar o layout!
      }}
    >
      {menuCollapsed ? (
        <ArrowDown color="black" size={20} />
      ) : (
        <ArrowLeft color="black" size={20} />
      )}
    </button>
  );
};

  return (
    <div 
      className="header-menu-sidebar"
      // ADICIONADO: Se encolher (!isExpanded), zera o espaçamento direito e centraliza
      style={!isExpanded ? { paddingRight: 0, justifyContent: 'center' } : {}}
    >
      
      {/* SÓ MOSTRA A MINI LOGO SE O MENU ESTIVER ENCOLHIDO (!isExpanded) */}
      {!isExpanded && (
        // ADICIONADO: Zera também o espaçamento esquerdo padrão do h1 para ficar no centro perfeito
        <div className="brand-logo" style={{ paddingLeft: 0 }}>
          <NavLink to="/dashboard">
            <img src={miniLogo as string} alt="Logo Assistive - Ir para a página inicial" />
          </NavLink>
        </div>
      )}

      {/* SÓ MOSTRA A LOGO COMPLETA SE O MENU ESTIVER EXPANDIDO (isExpanded) */}
      {isExpanded && (
        <div className="brand-logo-full">
          <NavLink to="/dashboard">
            <img src={themeConfig.app.appLogoFull  as unknown as string} alt="Logo Assistive - Ir para a página inicial" />
          </NavLink>
        </div>
      )}

      {/* SÓ MOSTRA AS SETAS E O X SE O MENU ESTIVER EXPANDIDO */}
      {isExpanded && (
        <div className="d-flex align-items-center">
          <Toggler />
          <button
            onClick={() => { setMenuVisibility(false); }}
            className="btn-touch-target d-block d-xl-none"
            aria-label="Fechar menu"
          >
            <X className="toggle-icon icon-x" size={20} color="black"/>
          </button>
        </div>
      )}
    </div>
  );
};

export default VerticalMenuHeader;
{/*
  antigo retorno do navheader sidebar 
    <div className="navbar-header">
      <ul className="nav navbar-nav flex-row">
        <li className="nav-item me-auto" >
          <NavLink
            to={user ? getHomeRouteForLoggedInUser(user.role) : "/sites"}
            className="navbar-brand"
            ref={aRef}
          >
            <h1 className="brand-logo">
              <img src={themeConfig.app.appLogoImage  as unknown as string} alt="Logo Assistive" />
            </h1>
            <h1 className="brand-logo-full">
              <img src={themeConfig.app.appLogoFull  as unknown as string} alt="Logo Assistive" />
            </h1>
             <h2 className="brand-text mb-0">{themeConfig.app.appName}</h2> 
          </NavLink>
        </li>
        <li className="nav-item nav-toggle">
          <div className="nav-link modern-nav-toggle cursor-pointer" aria-label={notNullString(t("menu.hidMenu"))}>
            <Toggler  />
            <X
              onClick={() => {setMenuVisibility(false);}}
              className="toggle-icon icon-x d-block d-xl-none"
              size={20}
            />
          </div>
        </li>

      </ul>
    </div>*/}